import moment from 'moment';

type YearMonthStringProps = {
  yearMonth: string;
};

const YearMonthString = ({ yearMonth }: YearMonthStringProps) =>
  moment(yearMonth, 'YYYY-MM').format('MMM YYYY');

export default YearMonthString;
